
















import {Component, Prop, Mixins, Watch} from 'vue-property-decorator';
import Card from '@c/Card.vue';
import ModuleDeveloperActionMixin from '@/mixins/ModuleDeveloperActionMixin';
import {PMActionType} from '@/views/system/modules/enums';
import Diagram from '@/components/system/developerInfo/Diagram.vue';
import {ActionDiagramData} from '@/interfaces/diagrams';

@Component({
  components: {Card, Diagram},
})
export default class FullSpectrumAction extends Mixins(ModuleDeveloperActionMixin) {
  // хранилище
  @Prop()
  apiStore!: any;

  error = false;
  loading = true;

  actionType = PMActionType.GetFullSpectrum;

  data: ActionDiagramData = {
    values: [],
    leftX: 0,
    rightX: 0,
    size: 0,
    xTitle: 'Частота, Гц',
    yTitle: 'Амплитуда',
  };

  async build() {
    this.error = false;
    this.loading = true;
    this.sendAction(async () => {
      try {
        await this.apiStore.getFullSpectrumAction({
          id: this.pmodule?.id as number,
        });
      } catch {
        this.error = true;
      } finally {
        this.loading = false;
      }
    });
  }

  @Watch('result')
  async onLoadResult(newVal: any) {
    if (!newVal) return;
    const strParse = JSON.parse(newVal);
    if (strParse) {
      this.data = {
        ...this.data,
        leftX: strParse.data.left_x,
        rightX: strParse.data.right_x,
        values: strParse.data.values,
        size: strParse.data.size,
      };
    }
  }
}
